export default {
  title: '通知',
  center: '通知中心',
  markAllRead: '全部已读',
  markAllAsRead: '全部标为已读',
  markRead: '已读',
  noNotification: '暂无通知',
  unread: '未读',
  viewAll: '查看全部通知',
  allTitle: '全部通知',
  loadMore: '加载更多',
  newNotification: '新通知',
  allMarkedRead: '已全部标为已读',
  disablePopup: '通知不再弹出',
  enablePopup: '通知弹出',
  popupDisabled: '新通知将只更新铃铛角标',
  popupEnabled: '新通知将恢复弹出提醒',
  orderMatched: '订单已匹配',
  orderLocked: '订单已锁定',
  orderUnlocked: '订单已解锁',
}
